import { CUSTOMER_NEEDS } from '@ahmdigital/constants';
import { difference } from 'lodash/fp';

import { CHOOSABLE_60_PRODUCTS } from '../../ahm-constants/ui';

type Props = {
  needsProductType: string;
  needsType: string;
  productIds: string[];
};
// Generally the products for certain needs journeys are defined in the constants
// repo. However there is sometimes the need to exclude some choosable products
// for a particular journey (eg exclude choosable 60 products from all extras product listing)
const excludeChoosableForNeeds = ({ needsProductType, needsType, productIds }: Props) => {
  if (needsType === CUSTOMER_NEEDS.EXTRAS_COVER && needsProductType === CUSTOMER_NEEDS.ALL) {
    return difference(productIds, CHOOSABLE_60_PRODUCTS);
  }

  return productIds;
};

export default excludeChoosableForNeeds;
